export default "__VITE_ASSET__8f15c99f__"